<template>
  <a-modal
    title="发送记录"
    v-model="isShow"
    centered
    :mask-closable="false"
    :width="800"
  >
    <template slot="footer">
      <a-button class="ant-btn-primary" @click="closeModal">
        关闭
      </a-button>
    </template>

    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

  </a-modal>
</template>

<script>
import { findConfirmationFormSendRecordDetails } from '@/api/confirmation_form_send_record'
import Pagination from '@/components/Pagination'

export default {
  name: 'ConfirmationFormSendDetails',
  components: {
    Pagination
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      query: {},
      pagination: {
        total_count: 0
      }
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    columns() {
      return [
        {
          title: '记录编号',
          dataIndex: 'no'
        },
        {
          title: '发送时间',
          dataIndex: 'send_at'
        },
        {
          title: '发送方式',
          dataIndex: 'send_method'
        },
        {
          title: '查看状态',
          dataIndex: 'status_text'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findConfirmationFormSendRecordDetails(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
      })
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>

